import React, { useState } from "react";
import { Fragment } from "react";

import { Bar } from "react-chartjs-2";

import ModalGraph from "@image/icones/DocumentsEmployers/graph.svg";

import ButtonNextPrevious from "@entreprise/employeTab/container/statistic/ButtonNextPreviousStat";

import GraphModal from "./ContentModals";

export default React.memo(function Index({
  legends,
  graphData,
  title,
  graphOptions,
  target,
  graphPlugins = [],
  // height=100,
  description=null,
  parentClass="arh-mt-4",
  anotherClass=""
}) {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="arh-flex arh-border arh-border-solid arh-border-borderStat arh-p-6">
         <div className="arh-flex-1">
            <div className="arh-w-full arh-h-full arh-flex arh-relative">
               <div className="arh-basis-3/12">
                  <div className="arh-flex arh-flex-col arh-space-y-20 arh-px-8">
                    <h3 className="arh-m-0 arh-font-poppins arh-text-15 arh-font-bold arh-text-black">
                      {title}
                    </h3>
                    {legends}
                </div>
              </div>
              <div className={`arh-basis-9/12 ${parentClass}`}>
                <div className={`arh-flex arh-items-start`}>
                  <ButtonNextPrevious target={target}>
                    <div className={`arh-w-[30rem] ${anotherClass}`}> 
                      <Bar
                        data={graphData}
                        options={graphOptions}
                        //height={height}
                        plugins={graphPlugins}
                      />
                    </div>
                  </ButtonNextPrevious>
                </div>
                <button
                      className="arh-border-0 arh-bg-transparent arh-absolute arh-right-2 arh-top-0"
                      onClick={handleShowModal}
                >
                  <img alt="graph" src={ModalGraph} />
                </button>
              </div>
            </div>
         </div>
         <div className={description ? "arh-basis-3/12 arh-bg-greyColor arh-w-1/3 arh-p-4 arh-space-y-4 arh-font-poppins arh-font-normal arh-text-black arh-flex arh-items-center arh-justify-center arh-flex-col":"arh-hidden "}>
                  {description}
         </div>

      </div>
      
      <GraphModal
        show={showModal}
        onclickClose={handleShowModal}
        fragment={Fragment}
        title={title}
        legends={legends}
        graphData={graphData}
        graphOptions={graphOptions}
        graphPlugins={graphPlugins}
        target={target}
      />
    </>
  );
});
